import { FormControl, InputLabel, MenuItem, OutlinedInput, Select } from "@mui/material"
import { translate } from "app/language/service"
import React from "react"
import { IReportFilters, IReportParameters } from "reports/model"
import { setReportsParameters } from "reports/tools/common"
import { DatePicker } from "ui/components/DatePicker"
import { IPeriodFilter, NO_FILTER_KEY, getStartEndFilters } from "ui/model"

interface IStartEndDateFilterProps {
  isCreation: boolean
  filters: IReportFilters
}

const EMPTY_VALUE = "-1"

export const StartEndDateFilter = React.memo(({ isCreation, filters }: IStartEndDateFilterProps) => {
  let startDate = null
  let endDate = null
  const filterByLabelKey: { [labelKey: string]: IPeriodFilter } = {}
  const allLabelKeys: string[] = []
  const allFilters = getStartEndFilters()
  const allFilterLabelKeys = allFilters.map(f => f.labelKey)
  for (const filter of allFilters) {
    allLabelKeys.push(filter.labelKey)
    filterByLabelKey[filter.labelKey] = filter
  }
  let isFilter: boolean = false
  if (filters.startDate && allLabelKeys.includes(filters.startDate)) {
    // const filter = filterByLabelKey[filters.startDate]
    isFilter = true
    // startDate = filter.startDate
    // endDate = filter.endDate
  } else {
    if (filters.startDate) {
      startDate = new Date(filters.startDate)
    }
    if (filters.endDate) {
      endDate = new Date(filters.endDate)
    }
  }
  return (
    <>
      <FormControl id="reports-field-period" size="small">
        <InputLabel id="reports-field-period-label">{translate("reports.filters.range")}</InputLabel>
        <Select
          labelId="reports-field-period-label"
          id="reports-field-period-select"
          value={allFilterLabelKeys.includes(filters.startDate as string) ? filters.startDate : EMPTY_VALUE}
          onChange={event => {
            const newParameters: Partial<IReportParameters> = {
              filters: {
                ...filters,
                startDate: event.target.value === EMPTY_VALUE ? "" : event.target.value
              }
            }
            if (filters.endDate) {
              ; (newParameters as IReportParameters).filters.endDate = undefined
            }
            setReportsParameters(isCreation, newParameters)
          }}
          input={<OutlinedInput label={translate("report.group.sort.by.weather_id")} />}>
          <MenuItem value={EMPTY_VALUE}>{translate("reports.custom.range")}</MenuItem>
          {allFilters
            .filter(f => f.labelKey !== NO_FILTER_KEY)
            .map(filter => (
              <MenuItem key={filter.labelKey} value={filter.labelKey}>
                {translate(filter.labelKey)}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
      {!isFilter && (
        <>
          <DatePicker
            id="reports-field-start"
            value={startDate}
            label={translate("label.startDate")}
            disabled={isFilter}
            minTime
            maxDate={endDate || undefined}
            onChange={newStartDate =>
              setReportsParameters(isCreation, {
                filters: {
                  ...filters,
                  startDate: newStartDate && typeof newStartDate === "object" ? newStartDate.toISOString() : undefined
                }
              })
            }
          />
          <DatePicker
            id="reports-field-end"
            value={endDate}
            label={translate("label.endDate")}
            disabled={isFilter}
            maxTime
            minDate={startDate || undefined}
            onChange={newEndDate =>
              setReportsParameters(isCreation, {
                filters: {
                  ...filters,
                  endDate: newEndDate && typeof newEndDate === "object" ? newEndDate.toISOString() : undefined
                }
              })
            }
          />
        </>
      )}
    </>
  )
})
